import { Button, MessageBar, MessageBarBody } from "@fluentui/react-components";
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

import optiumLogo from "../../images/optium_logo.svg";

import { useAppOrgsAndInvitedOrgs } from "@/components/AppProvider/AppOrgsAndInvitedOrgsProvider";
import { OrganizationSwitchDialog } from "@/components/AppSideNav/AppSideNavGlobal/OrganizationSwitchDialog";
import { useCachedOrganization } from "@/components/InOrganizationProvider/OrganizationProvider";
import styles from "./index.module.css";

export const OrgUnderMaintenance: React.FC = () => {
  const { listeningOrganization } = useCachedOrganization();
  const { organizations } = useAppOrgsAndInvitedOrgs();
  const navigate = useNavigate();

  const [
    isOrganizationSwitchDialogVisible,
    setIsOrganizationSwitchDialogVisible,
  ] = useState(false);

  if (!listeningOrganization) return null;

  return (
    <>
      <div>
        <div className={styles.container}>
          <div className={styles.contentBox}>
            <div className={styles.logo}>
              <img src={optiumLogo} width={240} alt="OPTIUM" />
            </div>
            <p>組織 {listeningOrganization?.name} はメンテナンス中です</p>
            {listeningOrganization?.maintenanceDescription ? (
              <MessageBar
                intent="info"
                className={styles.maintenanceDescription}
              >
                <MessageBarBody>
                  {listeningOrganization.maintenanceDescription}
                </MessageBarBody>
              </MessageBar>
            ) : null}
            <div className={styles.buttons}>
              {organizations.length > 1 ? (
                <Button
                  appearance="primary"
                  className={styles.actionButton}
                  onClick={async () => {
                    setIsOrganizationSwitchDialogVisible(true);
                  }}
                >
                  組織の切り替え
                </Button>
              ) : null}
              <Button
                appearance="primary"
                className={styles.actionButton}
                onClick={() => navigate("/account_setting")}
              >
                アカウント設定
              </Button>
              <Button
                appearance="primary"
                className={styles.actionButton}
                onClick={async () => {
                  // @ts-ignore
                  window.signOut();
                }}
              >
                ログアウト
              </Button>
            </div>
          </div>
        </div>
      </div>
      {
        <OrganizationSwitchDialog
          isVisibleDialog={isOrganizationSwitchDialogVisible}
          closeDialog={() => {
            setIsOrganizationSwitchDialogVisible(false);
          }}
        />
      }
    </>
  );
};
